
class Tools{

  static translate(data){

    var translateMsg = function(msg_error){
      var msg = "";
      if(msg_error.indexOf("`password` can't be blank")>0){
        msg += "<br> - Mot de passe manquant.";
      }
      if(msg_error.indexOf("Email already exists")>0){
        msg += "<br> - Adresse email déjà utilisée.";
      }
      if(msg_error.indexOf("User already exists")>0){
        msg += "<br> - Username déjà utilisée.";
      }
      if(msg_error.indexOf("Ce titre est déjà utilisé")>0){
        msg += "<br> - Ce titre est déjà utilisé.";
      }
      if(msg_error.indexOf("Ce nom de groupe est déjà utilisé")>0){
        msg += "<br> - Ce nom de groupe est déjà utilisé.";
      }
      if(msg == ""){
        msg = msg_error;
      }
      return msg;
    }

    console.log("translate error",data);
    if(data.error){

      var checkDetailsError = function(data){
        var msg = "";
        if(data.error.details){
          if(Array.isArray(data.error.details)){
            for(var d=0;d<data.error.details.length;d++){
              msg += msg != "" ? "<br>" : "";
              if(data.error.details[d].message){
                msg += translateMsg(data.error.details[d].message);
              }
              return msg;
            }
          }
          else{
            if(data.error.details.messages){
              var keys = Object.keys(data.error.details.messages);
              for(var p=0;p<keys.length;p++){
                if(Array.isArray(data.error.details.messages[keys[p]])){
                  for(var a=0;a<data.error.details.messages[keys[p]].length;a++){
                    msg += msg != "" ? "<br>" : "";
                    msg += translateMsg(data.error.details.messages[keys[p]][a]);
                  }
                }
                else{
                  msg += translateMsg(data.error.details.messages[keys[p]])
                }
              }
            }
          }

        }
        return msg;
      }

      switch(data.error.code){
        case 'LOGIN_FAILED':
          return "Erreur identifiants incorrects.";
        break;
        case 'INVALID_PASSWORD':
          return "Mot de passe invalide.";
        break;
        default:
          switch(data.error.statusCode){
            case 422:
              var msg = "Erreur dans la saisie des données.";
              var msg_detail = checkDetailsError(data);
              if(msg_detail != "") return msg_detail;
              if(data.error.message){
                translateMsg(data.error.message);
              }
              return msg;
            break;
            default:
              var msg_detail = checkDetailsError(data);
              if(msg_detail != "") return msg_detail;
              if(data.error.message){
                  return data.error.message;
              }
              return "Erreur inconnue";
            break;
          }
        break;
      }
    }

    console.log("Translate ERROR - impossible : ",data);
    if(!data){
      return "Le serveur est inaccessible. Veuillez réessayer plus tard, merci."
    }
    return "Une erreur est survenue.";

  }

}

export { Tools as default }



// WEBPACK FOOTER //
// ./src/store/tools.js